export default __webpack_public_path__ + "static/media/lewis_of_man_lowdef.cfecdd7a.png";